import phrasebookLoad from "../i18n";
import React from "react";

export const capitalizeFirstLetter = (string) => {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

}
export const lowerFirstLetter = (string) => {
  if (string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
  }

}
export const queryFilters = (limit, page) => {
  return `?limit=${limit}&page=${page}`;
}

export const queryWhere = (filters, nolimit = undefined) => {
  var filterKeys = Object.keys(filters);
  var whereQuery = nolimit ? '?' : '';
  filterKeys.forEach(key => {
    if (filters[key] !== undefined) whereQuery = whereQuery.concat('', `&${key}=${filters[key]}`)
  })
  return whereQuery;
}

export var permissionFinder = (arrayToFind, account_type_id, functionality_id, permType, accountLogged) => {
  return arrayToFind.find((post, index) => {
    if (!functionality_id && !permType) {
      return true;
    } else {
      if (post.account_type_id == account_type_id && post.functionality_id == functionality_id && post[permType] == true) {
        if (accountLogged.customer_id !== null) {
          if (arrayToFind[index].customer_id == accountLogged.customer_id) return true;
          else return false;
        } else {
          return true;
        }
      } else return false;

    }

  });
}

export var categoryFinder = (arrayToFind, category) => {
  arrayToFind.find(function (post, index) {
    if (post.category == category) return true;
    else return false;

  });
}

export var categoryGroupBy = (arrayPermissions) => {
  var categories = [];
  arrayPermissions.forEach(permission => {
    if (!categories.includes(permission.functionality.category) && permission.list == true) categories.push(permission.functionality.category);
  });
  return categories;
}

// Local Libraries


const phrasebook = phrasebookLoad();

export var trueOrFalse = (value) => {
  return value == true ? phrasebook.common.yes : phrasebook.common.no;
}

export var trueOrFalseIfExist = (value) => {
  if (value == true) return phrasebook.common.yes;
  else if (value == false) return phrasebook.common.no;
  else return 'N/A';
}

export var required = (value) => {
  return value == true ? phrasebook.common.required : phrasebook.common.no_required;
}

export var ifZero = (value) => {
  if ([undefined, null].includes(value)) return 'N/A';
  else return value;
}

export var noMaximum = (value) => {
  return value ? value : 'N/A';
}

export var specialMaximum = (value) => {
  if (!value) {
    return "Depends on local carrier settings"
  } else if (value == 999 || value == '999') {
    return "Depends on local carrier settings"
  } else return value;
}

export var applicable = (value) => {
  return value ? value : 'N/A';
}

export var isClassComponent = (component) => {
  return (
    typeof component === 'export var ' &&
    !!component.prototype.isReactComponent
  )
}

export var isFunctionComponent = (component) => {
  return (
    typeof component === 'export var ' &&
    String(component).includes('return React.createElement')
  )
}

export var isReactComponent = (component) => {
  return (
    isClassComponent(component) ||
    isFunctionComponent(component)
  )
}

export var isElement = (element) => {
  return React.isValidElement(element);
}

export var isDOMTypeElement = (element) => {
  return isElement(element) && typeof element.type === 'string';
}

export var isCompositeTypeElement = (element) => {
  return isElement(element) && typeof element.type === 'export var ';
}

export var checkerelement = (element) => {
  console.log(`Esto es isClassComponent ${isClassComponent(element)}`);
  console.log(`Esto es isFunctionComponent ${isFunctionComponent(element)}`);

  console.log(`Esto es isReactComponent ${isReactComponent(element)}`);

  console.log(`Esto es isElement ${isElement(element)}`);

  console.log(`Esto es isDOMTypeElement ${isDOMTypeElement(element)}`);

  console.log(`Esto es isCompositeTypeElement ${isCompositeTypeElement(element)}`);
}
